import { tgxApi } from "../../../app/tgxApi";
import {
    getAuthorizationHeader,
    getFileDownloadHeaders,
    handleQueryError,
    handleQueryErrorAndSuccess,
} from "../../../helpers/utils/RtkQueryUtils";
import { getFileName, serialize } from "../../../helpers/utils/Utils";
import { downloadFile } from "../../../helpers/utils/FileUtils";

export const ThirdPartyProviderApi = tgxApi.injectEndpoints({
    endpoints: (build) => ({
        searchThirdPartyProviderApi: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/ajax/third-party-providers/search?${paramData}`,
                    method: 'POST',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['thirdPartyProvider'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getThirdPartyProviderById: build.query({
            query: (id) => {
                return {
                    url: `/ajax/get-third-party-provider-by-id/${id}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['thirdPartyProviderById'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getNotesByProviderId: build.query({
            query: (id) => {
                return {
                    url: `/ajax/get-third-party-provider-notes-by-id/${id}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['thirdPartyProviderNotesById'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

        updateThirdPartyProviderDetailApi: build.mutation({
            query: ({ requestBody, providerId }) => {
                return {
                    url: `/ajax/update-third-party-provider/${providerId}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['thirdPartyProviderById','thirdPartyProvider'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Third Party Provider Detail");
            },
        }),

        createThirdPartyProviderDetailApi: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/ajax/third-party-provider/create`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['thirdPartyProvider'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Created", "Third Party Provider Detail");
            },
        }),
        createThirdPartyProviderNotes: build.mutation({
            query: ({id,requestBody}) => {
                return {
                    url: `/ajax/create-third-party-provider-note/${id}`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['thirdPartyProviderNotesById'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Created", "Third Party Provider Detail");
            },
        }),
        exportThirdPartyProviderData: build.query({
            query: (query) => {
                return {
                    url: `/export/third-party-providers?`,
                    method: 'POST',
                    params: query,
                    headers: getFileDownloadHeaders(),
                    responseType: 'arraybuffer',
                    responseHandler: async (response: { blob: () => any; }) => {
                        const blob = await response.blob();
                        downloadFile(blob, getFileName("third_party_provider"))
                        return { success: true };
                    },
                };
            },
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        deleteProviderById: build.mutation({
            query: (id) => {
                return {
                    url: `/ajax/delete-third-party-provider-by-id/${id}`,
                    method: 'DELETE',
                    headers: getAuthorizationHeader()
                };
            },
            invalidatesTags: ['thirdPartyProvider'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Deleted", "Third Party Provider");
            },
        }),

        deleteProviderNoteById: build.mutation({
            query: (id) => {
                return {
                    url: `/ajax/delete-third-party-provider-note-by-id/${id}`,
                    method: 'DELETE',
                    headers: getAuthorizationHeader()
                };
            },
            invalidatesTags: ['thirdPartyProviderNotesById'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Deleted", "Third Party Provider Note");
            },
        }),
    }),
});


export const {
    useGetThirdPartyProviderByIdQuery,
    useSearchThirdPartyProviderApiQuery,
    useLazyExportThirdPartyProviderDataQuery,
    useGetNotesByProviderIdQuery,
    useUpdateThirdPartyProviderDetailApiMutation,
    useCreateThirdPartyProviderDetailApiMutation,
    useDeleteProviderByIdMutation,
    useCreateThirdPartyProviderNotesMutation,
    useDeleteProviderNoteByIdMutation
} = ThirdPartyProviderApi;